import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import { Form, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import classNames from "classnames";
import { circleInfo } from "../../features/base64/images.constants";


const NumberComponent = ({ field, onFieldChange, fieldsResult, data }) => {

  useEffect(() => {
    const value = fieldsResult[field.name] || field.defaultValue
    onFieldChange(field.name, value);
    // eslint-disable-next-line
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {field.friendlyDescription}
    </Tooltip>
  );

  return (
    <Form.Group>
      <Row className="mx-n1 mb-3">
        <Col lg={6} className="px-1">
          <Form.Label className={classNames({ required: field.required })}>
            {field.friendlyName}
            {field.friendlyDescription && <OverlayTrigger
              placement="top"
              overlay={renderTooltip}
            >                
              <img className="ml-2" src={circleInfo} aria-hidden="true" x="0" y="0" height="14px" width="14px" />
            </OverlayTrigger>}
          </Form.Label>
        </Col>
        <Col lg={6} className="px-1">
          <NumberFormat
            type="text"
            className="form-control"
            onChange={e => onFieldChange(field.name, e.target.value)}
            required={field.required}
            value={data[field.name]}
            allowNegative={false}
            maxLength={100}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};

export default NumberComponent;
